import classNames from 'classnames';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import handleNavbarTransparency from 'helpers/handleNavbarTransparency';
import { topNavbarBreakpoint } from 'config';
import AppContext from 'context/Context';
import { useTranslation } from 'react-i18next';
import CountrySelector from './CountrySelector';

const NavbarStandard = ({ solid = false }) => {
  const {
    config: { isDark }
  } = useContext(AppContext);
  const [navbarCollapsed, setNavbarCollapsed] = useState(true);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (solid) {
      return;
    }
    window.addEventListener('scroll', handleNavbarTransparency);
    return () => window.removeEventListener('scroll', handleNavbarTransparency);
  }, [solid]);

  const textClass = solid ? 'text-900 fw-semi-bold' : 'text-white fw-semi-bold';
  const brandClass = solid
    ? 'text-900 fw-bold fs-2'
    : 'text-white dark__text-white fw-bold fs-2';

  const scrollTo = useCallback((e, id) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      setNavbarCollapsed(true);
      navigate(`/#${id}`);
      return;
    }

    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setNavbarCollapsed(true);
    }
  }, [location.pathname, navigate]);

  return (
    <Navbar
      variant={solid ? 'light' : (isDark ? 'light' : 'dark')}
      fixed="top"
      expand={topNavbarBreakpoint}
      className={classNames('navbar-standard navbar-theme', {
        'bg-white shadow-sm': solid,
        'bg-100': !navbarCollapsed && isDark,
        'bg-dark': !navbarCollapsed && !isDark
      })}
    >
      <Container>
        <Navbar.Brand className={brandClass} as={Link} to="/">
          Gestodo
        </Navbar.Brand>
        <Navbar.Toggle onClick={() => setNavbarCollapsed(!navbarCollapsed)} />
        <Navbar.Collapse className="scrollbar">
          <Nav className="ms-auto align-items-center">
            <Nav.Item>
              <Nav.Link href="#features" onClick={e => scrollTo(e, 'features')} className={textClass}>
                {t('LANDING.NAV_FEATURES')}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="#benefits" onClick={e => scrollTo(e, 'benefits')} className={textClass}>
                {t('LANDING.NAV_BENEFITS')}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="#pricing" onClick={e => scrollTo(e, 'pricing')} className={textClass}>
                {t('LANDING.NAV_PRICING')}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="#faq" onClick={e => scrollTo(e, 'faq')} className={textClass}>
                {t('LANDING.NAV_FAQ')}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/blog" className={textClass}>
                {t('LANDING.NAV_BLOG')}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="ms-lg-3">
              <Button
                as={Link}
                variant={solid ? 'outline-dark' : 'light'}
                className="rounded-pill px-4 fw-semi-bold"
                to="/login"
              >
                {t('LANDING.NAV_CLIENTS')}
              </Button>
            </Nav.Item>
            <CountrySelector />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarStandard;
